import React from 'react';
import { PageHero } from '../components/ui/PageHero';
import { QuoteBanner } from '../components/ui/QuoteBanner';
import { ReviewNote } from '../components/ui/ReviewNote';
import { ButtonLink } from '../components/ui/ButtonLink';
import { EquipmentCard } from '../components/equipment/EquipmentCard';
import { useSeo } from '../hooks/useSeo';
import { pageMeta } from '../data/seo';
import { equipment, equipmentCategories } from '../data/equipment';
import { heroImages } from '../data/images';
export function PlantEquipment() {
  useSeo(pageMeta.equipment, undefined, heroImages.equipment.src);
  return <>
      <PageHero title="Plant & equipment" intro="Earthmoving, road construction, haulage and building plant from the company's plant and equipment schedule." image={heroImages.equipment} breadcrumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Plant & Equipment'
    }]} data-id="element-795" data-mp="j4t4awdvi9yg" />

      <section className="bg-charcoal py-14" data-id="element-796" data-mp="1zij965cth295">
        <div className="mx-auto flex max-w-site flex-col gap-8 px-5 md:px-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-797" data-mp="3nwsx1gsj8ep8">
          <p className="max-w-2xl text-[18px] leading-relaxed text-steel-200" data-id="element-798" data-mp="3juxygk1zkff5">
            The equipment below is listed in the October 2026 company profile. Contact the team to talk through the plant a
            project will need.
          </p>
          <ButtonLink to="/contact?service=equipment#enquiry" showArrow className="self-start lg:self-auto" data-id="element-799" data-mp="39wru7vspix74">
            Discuss Equipment for Your Project
          </ButtonLink>
        </div>
        <div className="mx-auto mt-8 max-w-site px-5 md:px-8" data-id="element-800" data-mp="305x9wwz0u7ob">
          <ReviewNote data-id="element-801" data-mp="2w4txylk3gvsd">
            Quantities are as listed in the profile schedule. Registration numbers have been left out on purpose. Confirm
            current ownership and fleet size before launch.
          </ReviewNote>
        </div>
      </section>

      {equipmentCategories.map((category, index) => {
      const items = equipment.filter(item => item.category === category.id);
      return <section key={category.id} id={category.id} aria-labelledby={`${category.id}-title`} className={`py-16 md:py-20 ${index % 2 === 0 ? 'bg-charcoal-950' : 'bg-charcoal'}`} data-id="element-802" data-mp="27jywk241dch4" data-mpi={index}>
            <div className="mx-auto max-w-site px-5 md:px-8" data-id="element-803" data-mp="1ymetcnmm563v">
              <div className="flex flex-col gap-2 border-b border-white/15 pb-6 md:flex-row md:items-end md:justify-between" data-id="element-804" data-mp="22mf869dmjjbg">
                <h2 id={`${category.id}-title`} className="font-display text-[36px] font-extrabold uppercase leading-none text-white md:text-[44px]" data-id="element-805" data-mp="2qdb5tn4rh8qm">
                  {category.title}
                </h2>
                <p className="text-[15px] text-steel-300" data-id="element-806" data-mp="2hh3lg9p9nm1m">{category.description}</p>
              </div>
              <ul className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-807" data-mp="2li5cw4cxytt1">
                {items.map(item => <li key={item.id} data-id="element-808" data-mp="3e0kfncd1qbbj">
                    <EquipmentCard item={item} categoryTitle={category.title} data-id="element-809" data-mp="3e1m0g8jv6c6g" />
                  </li>)}
              </ul>
            </div>
          </section>;
    })}

      <QuoteBanner title="Need plant on your next project?" text="Tell us about the works, the location and the programme, and we will discuss the equipment involved." data-id="element-810" data-mp="xlphcl2yuv8d" />
    </>;
}